import { doRequest } from '../requests/actions';
import * as lib from './lib';

export const actions = {
  SET: 'CURRENT_USER_SET',
  CLEAR: 'CURRENT_USER_CLEAR',
  SET_ACTIVITY: 'CURRENT_USER_SET_ACTIVITY',
  FORWARD_ACTIVITY: 'CURRENT_USER_FORWARD_ACTIVITY',
  BACKWARD_ACTIVITY: 'CURRENT_USER_BACKWARD_ACTIVITY',
  SET_SCHEDULES: 'CURRENT_USER_SET_SCHEDULES',
  SET_PASSCODE: 'CURRENT_USER_SET_PASSCODE',
};

export function set(user) {
  return {
    type: actions.SET,
    value: user,
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}

export function setActivity(activity) {
  return {
    type: actions.SET_ACTIVITY,
    value: activity,
  };
}

export function forwardActivity(activity) {
  return {
    type: actions.FORWARD_ACTIVITY,
    value: activity,
  };
}

export function backwardActivity() {
  return {
    type: actions.BACKWARD_ACTIVITY,
  };
}

export function setSchedules(schedules) {
  return {
    type: actions.SET_SCHEDULES,
    value: schedules,
  };
}

export function loadUser(user) {
  return async (dispatch, getState) => {
    // set the user as the current user
    dispatch(set(user));
    dispatch(forwardActivity('home'));
    const currentUserID = user.get('id');

    if (user.get('userLevels').includes('employee')) { // can't clock in if not employee
      // fetch based on this ID
      const endpoint = lib.getScheduleUrl(user.get('id'));
      const rawSchedules = await dispatch(doRequest({ endpoint }));
      if (rawSchedules) {
        const schedules = lib.processSchedules(rawSchedules);
        const state = getState().toJS();
        if (state.currentUser.valid && state.currentUser.id === currentUserID) {
          dispatch(setSchedules(schedules));
        }
      }
    }

    return user;
  };
}

export function setCurrentUser(userId) {
  return async (dispatch, getState) => {
    const user = getState().get('employees').find(emp => emp.get('id') === userId);
    dispatch(loadUser(user));
  };
}



// WEBPACK FOOTER //
// ./src/store/currentUser/actions.js